// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Loading_spinner__tnR7P","loading":"Loading_loading__PVolH","loader":"Loading_loader__F_CvY","spin":"Loading_spin__9zyOV"};